import { extractNodes } from './storefront-graphql-helper'
import { isEmpty } from './utils'
import { handleize } from 'helpers/dom'

/**
 * @typedef UniqueSwatch
 * @property { SwatchColor } color
 * @property { string } handle
 * @property { ColourMetaobject } metafield
 * @property { Array<string> } options
 * @property { string } title
 * @property { Array<SwatchVariant> } variants
 * @property { { src: string, altText: string } } featuredImage
 */

/**
 * @typedef SwatchColor
 * @property { string } hex
 * @property { string } name
 */

/**
 * @typedef ColorMetaObject
 * @property
 * @property
 */

/**
 * @typedef SwatchVariant
 * @property { Array<string> } options
 * @property { { handle: string } } product
 * @property { Array<{ value: string }> }
 * @property { string } title
 */

/**
 * Used for setting the order of size swatches
 */
export const orderingArray = ['Single', 'King Single', 'Double', 'Queen', 'King']

/**
 *
 * @param { unknown } gqlData
 * @returns { Array<UniqueSwatch> }
 */
export const processSwatchData = (gqlData) => {
  if (!gqlData) {
    console.warn('Could not read gqlData in processSwatchData', gqlData)
    return []
  }
  const keys = Object.keys(gqlData)
  const products = keys
    .map(
      /**
       *
       * @param { unknown } key
       * @returns { UniqueSwatch }
       */
      (key) => {
        if (!gqlData[key]) return null
        if (!gqlData[key]?.node || isEmpty(gqlData[key]?.node)) return null

        // remove gql artifacts
        const product = extractNodes(gqlData[key].node, 'variants')

        if (!product.colorName) {
          return null
        }

        // set attributes used for swatch processing
        product.size = product.size?.value ?? '' // using instead of null to match default type of product
        product.video = product?.video?.value ?? null
        product.colorName = product.colorName?.value ?? null
        product.prettyColorName = product?.prettyColorName?.value ?? null
        product.sku = product?.variants?.map(variant => variant.sku) ?? null
        product.color = CD_STATE.CD_SWATCHES.find(
          /**
           *
           * @param {CD_SWATCHES} swatch
           * @returns { CD_SWATCHES }
           */
          (swatch) => handleize(swatch.handle) === handleize(product.colorName)
        ) ?? { handle: '' }

        // meet required structure without increasing nesting of gql query
        product.variants.forEach((variant) => {
          variant.product = { handle: product.handle }
        })
        product.images = product.images?.nodes?.map((image) => image.url) ?? [product.featuredImage?.url]

        return product
      }
    )
    .filter((product) => product?.color?.handle || product?.size)

  return products
}
